// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
}

.principal {
  width: 100%;
}

.content {
  overflow-y: auto;
  height: calc(100vh - 80px);
}
.content.-lfp {
  height: calc(100vh - 160px);
}`, "",{"version":3,"sources":["webpack://./src/styles/customer-lfp/_layout.scss","webpack://./src/app/widgets/pages/one-column-page/one-column-page.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;ACCF;;ADEA;EACE,WAAA;ACCF;;ADEA;EACE,gBAAA;EACA,0BAAA;ACCF;ADCE;EACE,2BAAA;ACCJ","sourcesContent":[".header {\n  width: 100%;\n}\n\n.principal {\n  width: 100%;\n}\n\n.content {\n  overflow-y: auto;\n  height: calc(100vh - 80px);\n\n  &.-lfp {\n    height: calc(100vh - 160px);\n  }\n}\n",".header {\n  width: 100%;\n}\n\n.principal {\n  width: 100%;\n}\n\n.content {\n  overflow-y: auto;\n  height: calc(100vh - 80px);\n}\n.content.-lfp {\n  height: calc(100vh - 160px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
